import React from 'react'
import { Box, Typography } from '@mui/material'
import TopBar from 'components/TopBar'
import Navbar from 'components/Navbar'
import ImpersonationTopBar from 'components/ImpersonationTopBar'

const isTestEnv = window.location.hostname === 'shopdemo.musescabinets.com'

const Header = () => {
  return (
    <Box>
      <ImpersonationTopBar />
      {isTestEnv && (
        <Box
          sx={{
            width: '100%',
            py: 1,
            backgroundColor: '#d32f2f',
            textAlign: 'center'
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 'bold',
              fontSize: '14px',
              letterSpacing: '0.5px',
              textAlign: 'center'
            }}
          >
            This is NOT the official Muses Cabinets website. This site is for
            internal testing purposes only.
          </Typography>
        </Box>
      )}
      <TopBar />
      <Navbar />
    </Box>
  )
}

export default Header
